export const _getImgixUrlProps = (props: any) => {
  let urlParams = "";

  Object.entries(props).map((prop, index) => {
    urlParams = `${urlParams}${index > 0 ? "&" : ""}${prop[0]}=${prop[1]}`;
    return urlParams;
  });
  return urlParams;
};
